import { Fragment, useEffect, useState } from "react";
import { Outlet } from "react-router-dom";

import NavImg from "./components/NavImg";
import NavMenu from "./components/NavMenu";

import './style.scss'

const Header = props => {
    const [isVisible, setIsVisible] = useState(true);
    const [lastScrollY, setLastScrollY] = useState(0);

    useEffect(() => {
        const handleScroll = () => {
            const currentScrollY = window.scrollY;

            if (currentScrollY > lastScrollY && currentScrollY > 100) {
                setIsVisible(false);
            } else if (currentScrollY < lastScrollY) {
                setIsVisible(true);
            }

            setLastScrollY(currentScrollY);
        };

        window.addEventListener('scroll', handleScroll, { passive: true });
        return () => window.removeEventListener('scroll', handleScroll);
    }, [lastScrollY]);

    return <Fragment>
        <div className={`global-header-container ${isVisible ? 'show' : 'hide'}`}>
            <NavImg />
            <NavMenu />
        </div>
        <Outlet />
    </Fragment>
}

export default Header
